<div class="gascalc m-10">
  <h3 class="content-title">Gasdynamics Calculator</h3>
  <h4>Companion to Zucker & Biblarz <a href="https://www.wiley.com/en-us/Fundamentals+of+Gas+Dynamics%2C+3rd+Edition-p-9781119481706" target="_blank">"Fundamentals of Gas Dynamics", 3rd Edition</a></h4>
  <div class="content">
    <p style="line-height: 1.5rem;">This calculator reproduces Appendices G through J and calculates Oblique Shocks without the aid of the charts in Appendix D, having the Normal Shock formulations built-in. With the Gasdynamics Calculator, the user avoids any need for interpolation or extrapolation, and further manipulations needed to arrive at the desired final answers are easily done with any standard calculators. In addition to being a labor-saving aid, this calculator outputs some functions not tabulated in the appendices and enables the user to conveniently tackle many problems that require more realistic values of ɣ (without defaulting to 1.40).</p>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Isentropic Flow Parameters
            <span fxHide fxShow.gt-sm>
              &nbsp;&mdash; including Prandtl-Meyer Function) (Chapters 5 and 8, Section 12.8, APPENDIX G)
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-isentropic-flow></app-isentropic-flow>
      
      </mat-expansion-panel>
  
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Normal-Shock Parameters 
            <span fxHide fxShow.gt-sm>
              &nbsp;(Chapter 6, APPENDIX H)
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <nstab></nstab>
        
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Oblique Shock 
            <span fxHide fxShow.gt-sm>
              &nbsp;(Chapter 7, APPENDIX D)
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
  
        <!-- <app-oblique-shock></app-oblique-shock> -->
  
      </mat-expansion-panel>
  
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Fanno Flow 
            <span fxHide fxShow.gt-sm>
              &nbsp;(Chapter 9, APPENDIX I)
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <!-- <app-fanno-flow></app-fanno-flow> -->
        
      </mat-expansion-panel>
  
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Rayleigh Flow 
            <span fxHide fxShow.gt-sm>
              &nbsp;(Chapter 10, APPENDIX J)
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
  
        <!-- <app-rayleigh-flow></app-rayleigh-flow> -->
  
      </mat-expansion-panel>
  
    </mat-accordion>
  
  </div>
</div>